module.exports = __webpack_public_path__ + "static/media/Sharp_thumb.0359bde4.png";